var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("max abs t-0 l-0 round-md no-scroll bg-color-" + _vm.bgColor)},[_c('div',{staticClass:"max bg-fixed bg-pos-2 alpha-d7",style:(("filter: blur(11px); backgroundImage: url(" + _vm.bgImg + ")"))})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38ee4665","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/matte-widget.vue
// module id = null
// module chunks = 